import type {State} from './cashback-calculator'
import type {LocaleCode} from '@/locale/locales'

import {generateLocaleData} from './shared'

const CASHBACK = 0.75
const NUM_OF_FREE_USERS = 5

export const calculateCashback = (
    {monthlySpend, numOfEmployees}: State,
    localeCode: LocaleCode,
) => {
    const beyondPlanCost = generateLocaleData(localeCode).cost
    let paidUsers = numOfEmployees - NUM_OF_FREE_USERS
    let additionalUserCost = 0
    const earnedCashback = (monthlySpend * CASHBACK) / 100

    if (paidUsers > 0) {
        for (let i = 1; i < paidUsers + 1; i++) {
            additionalUserCost += getAdditionalUserCostByCountry(localeCode)
        }
    }

    const cap = beyondPlanCost + additionalUserCost

    return (earnedCashback < cap ? earnedCashback : cap) * 12
}

const getAdditionalUserCostByCountry = (localeCode: LocaleCode) => {
    switch (localeCode) {
        case 'da-dk':
            return 160
        case 'sv-se':
            return 210
        default:
            return 17.5
    }
}
